import { useSelector } from "react-redux";
import { selectShowThemeSwitcher } from "../../app/dataServiceFeatureFlagsSlice";

/**
 * Reads `showThemeSwitcher` from the Data Service `/features` API.
 * @returns Whether the Skylab `AuiHeader` theme switcher should be shown.
 */
export const useThemeSwitcherFeatureFlag = (): boolean => {
    return useSelector(selectShowThemeSwitcher);
};
